<template>
  <div @click="visible = true">
    <slot></slot>
    <a-modal
      v-model="visible"
      width="80vw"
      :footer="null"
      :centered="true"
      :closable="false"
      :maskClosable="false"
      :maskStyle="{ background: '#1c1c1c' }"
      wrapClassName="c-turn-modal"
    >
      <div class="c-turn">
        <template v-if="type === 'download'">
          <div class="title">
            {{ $t("light.downloadType") }}
          </div>
          <a-radio-group v-model="KeyboardType" class="radio-group">
            <a-radio class="radio" value="rgb65"> AM RGB 65 </a-radio>
            <a-radio class="radio" value="r2"> {{ $t("R2") }} </a-radio>
            <a-radio class="radio" value="r1"> {{ $t("R1") }} </a-radio>
          </a-radio-group>
        </template>
        <div class="title">
          {{ $t(type === "turn" ? "light.turn" : "light.download") }}
        </div>
        <a-radio-group v-model="lightIndex" class="radio-group">
          <a-radio class="radio" :value="4"> {{ $t("light.name") }} 1 </a-radio>
          <a-radio class="radio" :value="5"> {{ $t("light.name") }} 2 </a-radio>
          <a-radio class="radio" :value="6"> {{ $t("light.name") }} 3 </a-radio>
        </a-radio-group>
        <md-checkbox v-model="led" class="checkbox" v-if="hasKeyframes">
          {{ $t("selectVersion.led") }}
        </md-checkbox>
        <md-checkbox v-model="inSwitch" class="checkbox" v-if="hasKeyframes">
          {{ $t("selectVersion.inSwitch") }}
        </md-checkbox>
        <div class="buttons">
          <md-button class="button" @click="visible = false">
            {{ $t("cancel") }}
          </md-button>
          <md-button
            class="button"
            :disabled="!led && !inSwitch"
            @click="onTurn"
          >
            {{ $t("yes") }}
          </md-button>
        </div>
        <div class="tip" v-if="type === 'turn'">
          {{ $t("light.turnTip") }}
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { deepCopy, download } from "@/utils";

export default {
  name: "CProfileTurn",
  props: {
    content: Object,
    type: String,
  },
  data() {
    return {
      visible: false,
      lightIndex: 4,
      led: true,
      inSwitch: true,
      KeyboardType: "rgb65",
    };
  },
  computed: {
    ...mapState(["profile65GameBoy", "profileNew", "profile"]),
    hasKeyframes() {
      return (
        this.content &&
        this.content.keyframes &&
        this.content.keyframes.frame_data &&
        this.content.keyframes.frame_data.length
      );
    },
  },
  methods: {
    onTurn() {
      // AM RGB 65
      let page_data = deepCopy(this.profile65GameBoy.data.page_data);
      if (this.led)
        page_data[this.lightIndex + 1].frames = deepCopy(this.content.frames);
      if (this.inSwitch && this.hasKeyframes)
        page_data[this.lightIndex + 1].keyframes = deepCopy(
          this.content.keyframes
        );
      if (this.type === "download" && this.KeyboardType === "rgb65") {
        page_data[5].frames.valid = 2;
        page_data[5].keyframes.valid = 2;
        page_data[6].frames.valid = 2;
        page_data[6].keyframes.valid = 2;
        page_data[7].frames.valid = 2;
        page_data[7].keyframes.valid = 2;
        page_data[this.lightIndex + 1].frames.valid = this.led ? 1 : 2;
        page_data[this.lightIndex + 1].keyframes.valid = this.inSwitch ? 1 : 2;
        const file = new Blob([
          JSON.stringify({
            ...this.profile65GameBoy.data,
            page_data,
            key_layer: {
              ...this.profile65GameBoy.data.key_layer,
              valid: 2,
            },
          }),
        ]);
        const fileName = "AM-RGB-65.json";
        download(file, fileName);
        this.$message.info(this.$t("keyboard.downloadSuccessfully"));
      } else if (this.type === "turn") {
        this.$store.dispatch("profile65GameBoy/setData", {
          ...this.profile65GameBoy.data,
          page_data,
        });
        this.$store.dispatch(
          "profile65GameBoy/setLightIndex",
          this.lightIndex + 1
        );
      }

      console.log("AM RGB 65");

      // R2
      page_data = deepCopy(this.profileNew.data.page_data);
      if (this.led)
        page_data[this.lightIndex + 1].frames = deepCopy(this.content.frames);
      if (this.inSwitch && this.hasKeyframes)
        page_data[this.lightIndex + 1].keyframes = deepCopy(
          this.content.keyframes
        );
      if (this.type === "download" && this.KeyboardType === "r2") {
        page_data[5].frames.valid = 2;
        page_data[5].keyframes.valid = 2;
        page_data[6].frames.valid = 2;
        page_data[6].keyframes.valid = 2;
        page_data[7].frames.valid = 2;
        page_data[7].keyframes.valid = 2;
        page_data[this.lightIndex + 1].frames.valid = this.led ? 1 : 2;
        page_data[this.lightIndex + 1].keyframes.valid = this.inSwitch ? 1 : 2;
        const file = new Blob([
          JSON.stringify({
            ...this.profileNew.data,
            page_data,
            key_layer: {
              ...this.profileNew.data.key_layer,
              valid: 2,
            },
          }),
        ]);
        const fileName = "AM-CB.json";
        download(file, fileName);
        this.$message.info(this.$t("keyboard.downloadSuccessfully"));
      } else if (this.type === "turn") {
        this.$store.dispatch("profileNew/setData", {
          ...this.profileNew.data,
          page_data,
        });
        this.$store.dispatch("profileNew/setLightIndex", this.lightIndex + 1);
      }
      console.log("R2");

      // R1
      let lightEffects = deepCopy(this.profile.data.lightEffects);
      if (this.led)
        lightEffects[this.lightIndex].frames = this.getFrames(
          deepCopy(this.content.frames.frame_data)
        );
      if (this.inSwitch && this.hasKeyframes)
        lightEffects[this.lightIndex + 7].frames = this.getKeyFrames(
          deepCopy(this.content.keyframes.frame_data)
        );
      lightEffects[this.lightIndex].speed.value = 10;
      if (this.type === "download" && this.KeyboardType === "r1") {
        const file = new Blob([
          JSON.stringify({
            ...this.profile.data,
            lightEffects,
          }),
        ]);
        const fileName = "AM-CBR1&XMAS.json";
        download(file, fileName);
        this.$message.info(this.$t("keyboard.downloadSuccessfully"));
      } else if (this.type === "turn") {
        this.$store.dispatch("profile/setData", {
          ...this.profile.data,
          lightEffects,
        });
        this.$store.dispatch("profile/setLightIndex", this.lightIndex);
        this.$message.info(this.$t("keyboard.turnSuccessfully"));
      }
      console.log("R1");

      this.visible = false;
    },
    getFrames(frames) {
      let frameData = [];
      frames.map((frame, index) => {
        let frameRGB = [];
        for (let i = 0; i < 40; i++) {
          for (let j = 0; j < 5; j++) {
            frameRGB.push(frame.frame_RGB[j * 40 + i]);
          }
        }
        frameData.push({
          frameRGB,
          frameIndex: index + 1,
        });
      });
      return frameData;
    },
    getKeyFrames(frames) {
      frames.map((frame) => {
        let frameRGB = new Array(84);
        frameRGB[0] = frame.frame_RGB[0];
        frameRGB[1] = frame.frame_RGB[0];
        frameRGB[2] = frame.frame_RGB[1];
        frameRGB[3] = frame.frame_RGB[2];
        frameRGB[4] = frame.frame_RGB[3];
        frameRGB[5] = frame.frame_RGB[4];
        frameRGB[6] = frame.frame_RGB[5];
        frameRGB[7] = frame.frame_RGB[6];
        frameRGB[8] = frame.frame_RGB[7];
        frameRGB[9] = frame.frame_RGB[8];
        frameRGB[10] = frame.frame_RGB[9];
        frameRGB[11] = frame.frame_RGB[10];
        frameRGB[12] = frame.frame_RGB[11];
        frameRGB[13] = frame.frame_RGB[12];
        frameRGB[14] = frame.frame_RGB[13];
        frameRGB[70] = frame.frame_RGB[14];

        frameRGB[15] = frame.frame_RGB[15];
        frameRGB[16] = frame.frame_RGB[16];
        frameRGB[17] = frame.frame_RGB[17];
        frameRGB[18] = frame.frame_RGB[18];
        frameRGB[19] = frame.frame_RGB[19];
        frameRGB[20] = frame.frame_RGB[20];
        frameRGB[21] = frame.frame_RGB[21];
        frameRGB[22] = frame.frame_RGB[22];
        frameRGB[23] = frame.frame_RGB[23];
        frameRGB[24] = frame.frame_RGB[24];
        frameRGB[25] = frame.frame_RGB[25];
        frameRGB[26] = frame.frame_RGB[26];
        frameRGB[27] = frame.frame_RGB[27];
        frameRGB[28] = frame.frame_RGB[28];
        frameRGB[69] = frame.frame_RGB[29];

        frameRGB[29] = frame.frame_RGB[30];
        frameRGB[30] = frame.frame_RGB[31];
        frameRGB[31] = frame.frame_RGB[32];
        frameRGB[32] = frame.frame_RGB[33];
        frameRGB[33] = frame.frame_RGB[34];
        frameRGB[34] = frame.frame_RGB[35];
        frameRGB[35] = frame.frame_RGB[36];
        frameRGB[36] = frame.frame_RGB[37];
        frameRGB[37] = frame.frame_RGB[38];
        frameRGB[38] = frame.frame_RGB[39];
        frameRGB[39] = frame.frame_RGB[40];
        frameRGB[40] = frame.frame_RGB[41];
        frameRGB[41] = frame.frame_RGB[42];
        frameRGB[42] = frame.frame_RGB[43];
        frameRGB[68] = frame.frame_RGB[44];

        frameRGB[43] = frame.frame_RGB[45];
        frameRGB[44] = frame.frame_RGB[46];
        frameRGB[45] = frame.frame_RGB[47];
        frameRGB[46] = frame.frame_RGB[48];
        frameRGB[47] = frame.frame_RGB[49];
        frameRGB[48] = frame.frame_RGB[50];
        frameRGB[49] = frame.frame_RGB[51];
        frameRGB[50] = frame.frame_RGB[52];
        frameRGB[51] = frame.frame_RGB[53];
        frameRGB[52] = frame.frame_RGB[54];
        frameRGB[53] = frame.frame_RGB[55];
        frameRGB[54] = frame.frame_RGB[56];
        frameRGB[55] = frame.frame_RGB[58];
        frameRGB[56] = frame.frame_RGB[59];

        frameRGB[57] = frame.frame_RGB[60];
        frameRGB[58] = frame.frame_RGB[62];
        frameRGB[59] = frame.frame_RGB[63];
        frameRGB[60] = frame.frame_RGB[64];
        frameRGB[61] = frame.frame_RGB[65];
        frameRGB[62] = frame.frame_RGB[66];
        frameRGB[63] = frame.frame_RGB[67];
        frameRGB[64] = frame.frame_RGB[68];
        frameRGB[65] = frame.frame_RGB[69];
        frameRGB[66] = frame.frame_RGB[70];
        frameRGB[67] = frame.frame_RGB[71];
        frameRGB[82] = frame.frame_RGB[72];
        frameRGB[83] = frame.frame_RGB[73];

        frameRGB[71] = frame.frame_RGB[75];
        frameRGB[72] = frame.frame_RGB[76];
        frameRGB[73] = frame.frame_RGB[77];
        frameRGB[74] = frame.frame_RGB[79];
        frameRGB[75] = frame.frame_RGB[80];
        frameRGB[76] = frame.frame_RGB[81];
        frameRGB[77] = frame.frame_RGB[85];
        frameRGB[78] = frame.frame_RGB[86];
        frameRGB[79] = frame.frame_RGB[87];
        frameRGB[80] = frame.frame_RGB[88];
        frameRGB[81] = frame.frame_RGB[89];

        frame.frame_RGB = frameRGB;
      });

      let frameData = [];

      frames.map((frame) => {
        frame.frame_RGB.map((RGB) => {
          if (
            !frameData[frameData.length - 1] ||
            frameData[frameData.length - 1].frameRGB.length === 200
          ) {
            frameData.push({
              frameIndex: frameData.length + 1,
              frameRGB: [],
            });
          }
          frameData[frameData.length - 1].frameRGB.push(RGB);
        });
      });

      return frameData;
    },
  },
};
</script>
<style lang="scss" scoped>
.c-turn {
  @include flex-center;
  width: 900px;
  flex-direction: column;
  margin: 0 auto;
  position: relative;

  .title,
  .tip {
    font-size: 24px;
    color: $active-color;
    margin-bottom: 10px;
    text-align: center;
  }

  .tip {
    font-size: 16px;
    margin-top: 30px;
    color: #ffffff;
  }

  .radio-group {
    margin-bottom: 30px;

    .radio {
      @include flex-center;
      height: 50px;
      line-height: 50px;
      color: #ffffff;
      justify-content: flex-start;

      &:hover {
        color: $active-color;
      }
    }
  }

  .checkbox {
    color: #ffffff;
    font-size: 22px;

    &:hover {
      color: $active-color;
    }
  }

  .buttons {
    @include flex-center;
    width: 100%;
    margin-top: 40px;

    .button {
      width: 150px;
      height: 53px;
      background-color: $active-color;
      border-radius: 5px;
      font-size: 20px;
      text-transform: none;

      & + .button {
        margin-left: 100px;
      }
    }
  }
}
</style>
<style lang="scss">
.c-turn {
  .radio-group {
    .radio {
      .ant-radio-inner {
        border: 2px solid $active-color !important;

        &::after {
          background-color: $active-color !important;
        }
      }
    }
  }
}
</style>
